export default function subtractOneSecond(from: Date): Date {
  return new Date(from.getTime() - 1000);
}
